var modMyLoyaltyCard = function(){
    var scope = ".js-mod-my-loyalty-card";
    ui.ready(scope,function($mod){

        var $confirmButton = $mod.find(scope+"__create-coupon-btn");

        $mod.find(scope+"__option").click(
            function(ev){
                ev.preventDefault();
                $(this).addClass("is-selected").siblings().removeClass("is-selected");
            }
        );
        $confirmButton.click(
            function(ev){
                ev.preventDefault();
                $confirmButton.prop("disabled",true);
                var couponID = $mod.find(scope+"__option.is-selected").eq(0).data("coupon");
                gvf.endpoint(
                    "web\\couponController::createLoyaltyCoupon",
                    [couponID],
                    function(response){
                        if(response.status=="ok"){
                            utils.alertEndpointResponse(
                                response,
                                function(){
                                    window.location.reload();
                                }
                            );
                        }else{
                            utils.alertEndpointResponse(response);
                        }
                });
            }
       );
    });
}();
